import React, { useState } from "react"
import { graphql } from "gatsby"
import { withPrismicPreview } from "gatsby-plugin-prismic-previews"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { SliceZone } from "../components/slices"

const StandardPage = ({ data, location }) => {
  const { enquiryType } = location?.state || {}

  const { meta_title, meta_description, keywords, body } =
    data?.prismicStandardPage?.data
  const { uid, page_data } = data?.prismicStandardPage

  const keywordArray = keywords ? keywords.split(",") : []

  const activeColour = useState("#ffffff")

  return (
    <Layout $reverseHeader={page_data?.reverse_header}>
      <Seo
        title={meta_title?.text}
        description={meta_description?.text}
        keywords={keywordArray}
      />
      {body && (
        <SliceZone
          enquiryType={enquiryType}
          slices={body}
          pageTitle={uid}
          activeColour={activeColour}
        />
      )}
    </Layout>
  )
}

export const pageQuery = graphql`
  query pageBySlug($uid: String!) {
    prismicStandardPage(uid: { eq: $uid }) {
      _previewable
      uid
      page_data: data {
        reverse_header
      }
      ...StandardPage
    }
  }
`

export default withPrismicPreview(StandardPage)
